import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  Typography,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import ProgressCell from "../../orders/ProgressCell";

function OpenContainersContent(props) {
  const methods = useFormContext();
  const { control, formState } = methods;
  const containerList = props?.data || [];

  const tableHeaderStyle = {
    backgroundColor: "#f5f6f8",
    fontSize: "15px",
    fontWeight: 500,
    color: "#4b5563",
    fontFamily: "Inter, sans-serif",
    padding: "12px",
    borderBottom: "1px solid #e5e7eb",
  };

  const tableCellStyle = {
    fontSize: "14px",
    fontWeight: 500,
    color: "#111827",
    fontFamily: "Inter, sans-serif",
    padding: "12px",
    borderBottom: "1px solid #e5e7eb",
    verticalAlign: "top",
  };

  if (!containerList || containerList.length === 0) {
    return (
      <Box className="mt-12 flex justify-center">
        <Typography variant="body1" color="textSecondary">
          No containers available
        </Typography>
      </Box>
    );
  }

  // page to display open containers in confirmed orders page
  return (
    <TableContainer
      component={Paper}
      className="border border-gray-300 rounded-md overflow-x-auto mt-12"
      sx={{
        maxWidth: "100%",
        "& .MuiTable-root": {
          minWidth: "900px",
        },
      }}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={tableHeaderStyle} align="center">
              Container Number
            </TableCell>
            <TableCell sx={tableHeaderStyle}>Capacity</TableCell>
            <TableCell sx={tableHeaderStyle}>Status</TableCell>
            <TableCell sx={tableHeaderStyle}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {containerList.map((container, index) => (
            <TableRow key={index}>
              {/* Container Number */}
              <TableCell sx={tableCellStyle} align="center">
                {container.container_number}
              </TableCell>

              {/* Capacity Progress Bar */}
              <TableCell sx={{ ...tableCellStyle, minWidth: "280px" }}>
                <ProgressCell
                  row={{
                    original: {
                      capacity_occupied: container.capacity_occupied,
                      capacity_allowed: container.capacity_allowed,
                    },
                  }}
                />
              </TableCell>

              {/* Status */}
              <TableCell sx={tableCellStyle}>
                <Box
                  sx={{
                    backgroundColor:
                      container?.load_status?.name === "Open"
                        ? "#D1FAE5"
                        : "#FEE2E2",
                    color:
                      container?.load_status?.name === "Open"
                        ? "#059669"
                        : "#DC2626",
                    px: 2,
                    py: 0.5,
                    borderRadius: "20px",
                    display: "inline-block",
                    fontSize: "13px",
                    fontWeight: 500,
                  }}
                >
                  {container?.load_status?.name || "Unknown"}
                </Box>
              </TableCell>

              {/* Action */}
              <TableCell sx={tableCellStyle}>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{
                    textTransform: "none",
                    borderColor: "#3b82f6",
                    color: "#3b82f6",
                    "&:hover": {
                      borderColor: "#2563eb",
                      backgroundColor: "#eff6ff",
                    },
                  }}
                  onClick={() => props.onContainerSelect(container)}
                >
                  Select
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default OpenContainersContent;
